import React from 'react';
import ReactJsonViewer from "react-json-view";
import {createSelector} from "reselect";
import {useSelector} from "react-redux";

const JsonViewer = ({value = {}, style = {}}) => {
    const selectLayoutMode = createSelector(
        (state: any) => state.Layout,
        (layout) => localStorage.getItem("layoutMode") || layout.layoutMode);

    const layoutMode = useSelector(selectLayoutMode);

    return <ReactJsonViewer src={value || {}} style={style} name={false}
                            theme={layoutMode === "dark" ? "ashes" : "rjv-default"}/>;
};

export default JsonViewer;